export enum FieldNames {
  Sites = 'sites',
  Sectors = 'sectors',
  Reset = 'reset',
}
